import axios from "axios";
import api from "./api";

export default class CommonApi {
  static async getMemberCount(params) {
    return await api.get(`admin/member/count`, params);
  }
  static async getVisitorCount(data) {
    return await api.get(`visit`, data);
  }

  static async fileDownload(data) {
    return await api.post(`common/file/download`, data, {
      responseType: "blob",
    });
  }
  static async fileUpload(data, onUploadProgress) {
    return await api.send({
      method: "POST",
      url: `common/file/upload`,
      data,
      onUploadProgress,
    });
  }

  static async getFileUploadUrl(data) {
    return await api.post(`common/file/upload-url`, data);
  }

  static async cloudFileUpload(url, file, onUploadProgress) {
    return await axios.put(url, file, {
      headers: {
        "Content-Type": file.type || "application/octet-stream",
      },
      onUploadProgress,
    });
  }
}
